import { z } from 'zod'

/**
 * Where a business that Sales pays stands (docs/sales.spec.md, "Stripe"):
 * still answering Stripe's questions, taking payments, or held up until it
 * answers more. Mirrors the `SalesBusinessStatus` enum in the Prisma schema —
 * the two must stay in sync.
 */
export const SALES_BUSINESS_STATUSES = ['onboarding', 'active', 'restricted'] as const

export const salesBusinessStatusSchema = z.enum(SALES_BUSINESS_STATUSES)

export type SalesBusinessStatus = z.infer<typeof salesBusinessStatusSchema>
